import { Button, Dropdown, Menu, Modal, Select, Space } from "antd";
import { Option } from "antd/lib/mentions";
import React, { Component } from "react";
import "./app_modal.css";
import { ReactComponent as SortIcon } from "../../../Sort.svg";
import UtilBloc from "../../../bloc/util_bloc";

class AppModal extends Component {
    constructor(props) {
        super(props);
    }

    handleNegativePress = () => {
        this.props.handleNegativePress()
    }

    handlePositivePress = () => {
        this.props.handlePositivePress()
    }

    getNegativeButtonText = () => {
        return this.props.negativeButtonText;
    }

    getPositiveButtonText = () => {
        return this.props.positiveButtonText;
    }

    render() {
        return (
            <>
                <Modal
                    open={this.props.open}
                    onCancel={this.props.handleModalClose}
                    footer={null}
                    width={this.props.width}
                    closable={this.props.closable}
                    className={'content_container'}
                >
                    <div className="p-3">
                        <div className="modal_title">{this.props.title}</div>
                        <div className="modal_subtitle mt-2">{this.props.subtitle}</div>

                        {this.props.children}

                        {
                            !UtilBloc.isNullOrEmpty(this.getPositiveButtonText()) &&
                            <div className="d-flex justify-content-end mt-4">
                                {
                                    !UtilBloc.isNullOrEmpty(this.getNegativeButtonText()) &&
                                    <Button
                                        type="text"
                                        onClick={() => this.handleNegativePress()}
                                        style={{ color: '#EE7623', height: '40px', width: '170px', fontWeight: 600 }}>
                                        {this.getNegativeButtonText()}
                                    </Button>
                                }
                                <Button
                                    type="text"
                                    onClick={() => this.handlePositivePress()}
                                    style={{ color: '#FFFFFF', backgroundColor: '#183028', height: '40px', width: '170px', fontWeight: 600 }}
                                >
                                    {this.getPositiveButtonText()}
                                </Button>
                            </div>
                        }

                    </div>
                </Modal>
            </>
        );
    }
}

export default AppModal;
